import { Component } from '@angular/core';
import { UserPreferencesService } from '../../../generics/services/user-preferences.service';

@Component({
    selector: 'app-footer-cmp',
    templateUrl: 'footer.component.html'
})

export class FooterComponent {
  test: Date = new Date();

  selectedLanguage: string = "en";

  constructor(public preferencesService: UserPreferencesService) {
    this.selectedLanguage = this.preferencesService.language;
  }


  public changeLanguage(lang: string) {
    this.preferencesService.changeLanguage(lang);
    this.selectedLanguage = this.preferencesService.language;

  }

}
